
define('text!Magento_Checkout/template/payment/before-place-order.html',[],function () { return '<!--\n/**\n * Copyright © Magento, Inc. All rights reserved.\n * See COPYING.txt for license details.\n */\n-->\n<!-- ko foreach: { data: elems, as: \'element\' } -->\n<!-- ko if: hasTemplate() -->\n<!-- ko template: getTemplate() --><!-- /ko -->\n<!-- /ko -->\n<!-- /ko -->\n';});

